import { message } from "antd";
import { useCallback, useEffect } from "react";
import { useSearchParams } from "react-router-dom";

import { useGetOrganizations } from "../api/v1";
import { SelectOption } from "../libs/types";
import { mapToSelectOptions } from "../libs/utils";

export function useOrganizationSelection() {
  const [searchParams, setSearchParams] = useSearchParams();
  const { organizations, isLoadingOrganizations, isErrorOrganizations } = useGetOrganizations();

  const orgId = searchParams.get("orgId");

  useEffect(() => {
    if (isErrorOrganizations) {
      message.error("Unable to fetch organizations");
    }
  }, [isErrorOrganizations]);

  useEffect(() => {
    const firstOrgId = organizations[0]?.orgId;
    if (!firstOrgId || searchParams.get("orgId")) return;

    const updatedParams = new URLSearchParams(searchParams);
    updatedParams.set("orgId", firstOrgId);
    setSearchParams(updatedParams);
  }, [organizations, searchParams, setSearchParams]);

  const organizationOptions = mapToSelectOptions(organizations, {
    labelKey: "name",
    valueKey: "orgId",
  }) as SelectOption[];

  const changeSelectedOrgId = useCallback(
    (nextOrgId: string) => {
      const updatedParams = new URLSearchParams(searchParams);

      if (nextOrgId) updatedParams.set("orgId", nextOrgId);
      else updatedParams.delete("orgId");

      setSearchParams(updatedParams);
    },
    [searchParams, setSearchParams]
  );

  return {
    orgId,
    organizations,
    organizationOptions,
    changeSelectedOrgId,
    isLoadingOrganizations,
  };
}
